export default __webpack_public_path__ + "static/media/oneforce-template-meme-white.72c6bb9a.png";